import React from 'react';
import { dashBoardformatDate, formatDate } from '../../../../utils';
import { fetchConfigarationData , kudzuPlusTrueFun } from '../../../../helpers/utils/Utils';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
const appConfigData = await fetchConfigarationData();

const SavingsTransactionCard = ({ transactionData }) => {
  const { IconUri, Description, TransactionTime, ExternalStatus, Amount, DrCrIndicator, StatusCode,IsCoveredByKudzuTransaction
    , goalName , amount , processedDate, debitCreditIndicator
  } = transactionData;
  const formattedDate = dashBoardformatDate(processedDate);
    const { t } = useTranslation();
  const date = formattedDate;
  // const StatusCode='APP';
  const isPending = StatusCode === 'APP';
  const externalText =  StatusCode === 'APP' ? 'Pending' : '';
  const isCredit = debitCreditIndicator === "Cr" ? true : false;
  const textColor = debitCreditIndicator === "Cr" ? "text-kudzu-text" : "text-secondary-3";
  const prefix = debitCreditIndicator === "Cr" ? "+ " : "- ";
  //{`${isPending ? 'italic text-secondary-3 opacity-50' : 'text-secondary-3'}`}
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);


  const styleAll = `font-[400] my-auto font-[500] font-hanken-grotesk md:text-[18px] sm:text-[11px] text-[16px]`
  const styleStatus = `font-[400] y-auto font-hanken-grotesk md:text-[18px] md:text-[17px] sm:text-[11px] text-[16px] `
  //text-[#262B3A]
  return (
   


       
      <tr className={`${IsCoveredByKudzuTransaction ? 'cursor-pointer' : 'cursor-pointer'}`}>
      {/* <td className='pb-5 pr-[.5rem]'><img src={IconUri} alt="Icon" className='lg:w-[35px] md:w-[34px] sm:w-[30px] w-[33px]' /></td> */}

      <td className={`pb-5 text-left font-[500] lg:max-w-[11rem] md:max-w-[10rem] sm:max-w-[6rem]
       max-w-[11rem] break-words  ${styleAll} 
       ${IsCoveredByKudzuTransaction ? "text-[#30BC89]" : 'text-[var(--text-clr-transactions)]'}`}>
        {goalName}
        <p className={` ${isPending ? 'text-[var(--text-clr-transactions)]' : 'text-[var(--text-clr-transactions-inactive)]'} sm:hidden block text-[13px] font-hanken-grotesk font-[400] mt-[0.3rem]`}>
          {date}
        </p>
      </td>

      <td className={`pb-5 text-left font-[500] hidden sm:table-cell ${styleAll}
      ${!isPending ? 'text-[var(--text-clr-transactions)]' : 'text-[var(--text-clr-transactions)]'}`}>{date}</td>

      <td className={`italic pb-5 text-left hidden sm:table-cell ${styleStatus} 
      ${isPending ? 'text-[var(--text-clr-transactions)]' : isCredit ? 'text-[var(--text-clr-transactions-credit)]' : 'text-[var(--text-clr-transactions)]'}
      `}>
        {externalText}
      </td>

      <td className={`sm:table-cell  flex justify-end  pb-5 text-right font-[500] ${styleAll} ${isPending ? 'text-[var(--text-clr-transactions)]' : isCredit ? 'text-[var(--text-clr-transactions-credit)]' : (IsCoveredByKudzuTransaction && kudzuPlusTrue) ? 'text-[var(--text-clr-transactions)]' : 'text-[var(--text-clr-transactions)]'}`}
      >
        {prefix}
        {parseInt(amount)}
        .{(amount % 1).toFixed(2).slice(2)}
        <p className={`${isPending ? 'text-[var(--text-clr-transactions)]' : isCredit ? 'text-[var(--text-clr-transactions-credit)]' : 'text-[var(--text-clr-transactions)]'}
        italic text-[13px] font-[400] sm:hidden block`}> {externalText}</p>
      </td>
    </tr>
  );
};



export default SavingsTransactionCard;
